package com.appcreator.client.firebase.auth

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Modifier
import com.appcreator.blueprint.components.forms.InputComponent
import com.appcreator.blueprint.core.EnvStore
import com.appcreator.blueprint.firebase.auth.FirebaseAuthSignInWithApple
import com.appcreator.blueprint.firebase.auth.FirebaseAuthSignInWithGoogle
import com.appcreator.compose.SuppressedException
import com.appcreator.compose.actions.Performer
import com.appcreator.compose.components.forms.InputComposable
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.EmailAuthProvider
import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.flow.filterNotNull
import kotlinx.coroutines.flow.first

@Composable
internal fun Reauthenticater(
    configureAppCheck: Boolean?
): Performer.Deferred {

    val passwordComponent = remember {
        InputComponent(
            _nodeId = null,
            _nodeLabel = null,
            _nodeRelativeId = null,
            label = null,
            placeholder = null,
            data = null,
            onChangeAction = null,
            onChangeDebouncedAction = null,
            maxCharacters = null,
            contentType = InputComponent.ContentType.Password,
            passwordVisibilityToggle = true,
            width = null,
            layoutType = InputComponent.LayoutType.Bordered,
            borderColor = null
        )
    }

    var password by remember { mutableStateOf("") }
    var showPasswordDialog by remember { mutableStateOf(false) }
    val passwordEntered = remember { mutableStateOf<Boolean?>(null) }

    if (showPasswordDialog) {
        AlertDialog(
            onDismissRequest = {
                showPasswordDialog = false
            },
            title = { Text("Re-enter Password") },
            text = {
                InputComposable(
                    modifier = Modifier,
                    component = passwordComponent,
                    value = password
                ) {
                    password = it
                }
            },
            confirmButton = {
                TextButton(onClick = {
                    passwordEntered.value = true
                    showPasswordDialog = false
                }) {
                    Text("Confirm")
                }
            },
            dismissButton = {
                TextButton(onClick = {
                    showPasswordDialog = false
                }) {
                    Text("Cancel")
                }
            }
        )
    }

    val signInWithGoogle = SignInWithGooglePerformer(FirebaseAuthSignInWithGoogle(configureAppCheck)).deferred()
    val signInWithApple = SignInWithApplePerformer(FirebaseAuthSignInWithApple()).deferred()

    return object : Performer.Deferred {
        override suspend fun perform(envStore: EnvStore) {
            Firebase.auth.currentUser?.let { user ->
                when {
                    user.providerData.any { it.providerId == AuthConsts.appleProviderId } -> signInWithApple.perform(envStore)
                    user.providerData.any { it.providerId == AuthConsts.googleProviderId } -> signInWithGoogle.perform(envStore)
                    user.providerData.any { it.providerId == AuthConsts.emailPasswordProviderId } -> {
                        showPasswordDialog = true
                        if(!snapshotFlow { passwordEntered.value }.filterNotNull().first()) throw SuppressedException(
                            IllegalStateException("User did not enter password"))
                        user.reauthenticate(EmailAuthProvider.credential(user.email!!, password))
                    }
                    else -> throw IllegalStateException("Unknown provider ${user.providerId} ${user.providerData.joinToString { it.providerId }}")
                }
            }
        }
    }
}